export class ToolTipManagerWeb {
    constructor() {
        this.closeDelay = 2000;
        if (!this.isMobileShop()) {
            this.bindEvents();
        }
    }
    bindEvents() {
        window.shell.subscribeTo('AAS.updateFinished', (payload) => {
            this.triggerInitToolTips(payload.querySelector);
        }, 'AAS.update');
    }
    triggerInitToolTips(selector = '.scope-aas.aas-full') {
        const scopeAas = document.querySelector(selector);
        if (!scopeAas)
            return;
        this.scope = scopeAas;
        this.registerEvents();
    }
    isMobileShop() {
        return document.documentElement.classList.contains('mobileshop');
    }
    registerEvents() {
        if (!this.scope)
            return;
        const tooltipContainers = Array.from(this.scope.querySelectorAll('.aas-tooltip-container'));
        tooltipContainers.forEach((container) => {
            const tooltip = container.querySelector('.aas-tooltip');
            if (!tooltip)
                return;
            container.addEventListener('mouseenter', () => this.handleMouseOverTooltipEvent(tooltip));
            container.addEventListener('mouseleave', () => this.handleMouseLeaveTooltipEvent(tooltip));
        });
    }
    handleMouseOverTooltipEvent(tooltip) {
        this.closeOpenTooltips();
        tooltip.classList.add('show-aas-tooltip');
        this.scrollTooltipIntoViewportIfNeeded(tooltip);
    }
    closeOpenTooltips() {
        if (!this.scope)
            return;
        const openTooltips = Array.from(this.scope.querySelectorAll('.aas-tooltip-container .aas-tooltip.show-aas-tooltip'));
        openTooltips.forEach((tooltip) => tooltip.classList.remove('show-aas-tooltip'));
    }
    scrollTooltipIntoViewportIfNeeded(tooltip) {
        const rect = tooltip.getBoundingClientRect();
        const tooltipBottom = rect.top + tooltip.clientHeight;
        if (this.shouldScrollUp(rect.top) || this.shouldScrollDown(tooltipBottom)) {
            tooltip.classList.add('scrollingToViewport');
            const scrollTo = this.shouldScrollUp(rect.top)
                ? rect.top - 20
                : tooltipBottom - window.innerHeight + 20;
            window.scrollBy({ behavior: 'smooth', top: scrollTo });
            setTimeout(() => tooltip.classList.remove('scrollingToViewport'), this.closeDelay);
        }
    }
    shouldScrollUp(top) {
        return top < 0;
    }
    shouldScrollDown(bottom) {
        return bottom > window.innerHeight;
    }
    handleMouseLeaveTooltipEvent(tooltip) {
        if (tooltip.classList.contains('scrollingToViewport')) {
            setTimeout(() => tooltip.classList.remove('show-aas-tooltip'), this.closeDelay);
        }
        else {
            tooltip.classList.remove('show-aas-tooltip');
        }
        tooltip.classList.remove('scrollingToViewport');
    }
}
new ToolTipManagerWeb();
